import { Injectable } from "@angular/core";
import { catchError, Observable, of, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CookieService } from "./cookie.service";
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  device_id: any
  header = { headers: { "Content-Type": "application/json" } }
  header2 = { headers: { "Content-Type": "application/json", 'request-id': 'b997a77ae2b3f30c1bed151c3e42434f' } }
  apiV2 = 'api/v2/cv_online/'
  apiV1 = 'api/v1/cv_online/'
  apiV3 = environment.apiUrl.includes('mobility') || environment.apiUrl.includes('digital-osp-cv-dev') ? 'api/v1/cv_online/' : 'api/'
  apiV4 = environment.apiUrl.includes('mobility') || environment.apiUrl.includes('digital-osp-cv-dev') ? 'api/v1/cv_online/v1/' : 'api/v1/'
  apiV5 = environment.apiUrl.includes('mobility') || environment.apiUrl.includes('digital-osp-cv-dev') ? 'api/v1/cv_online/' : ''

  private searchUnbxd = "https://search.unbxd.io/022d9e0d04f448a445126a43bfbaaf6e/ss-unbxd-prod-tatamotors49921702360514/"
  private translateText = `https://revapi.reverieinc.com/`
  private getCity = `${environment.apiUrl}${this.apiV1}cities/`
  private addressByPincode = `${environment.apiUrl}${this.apiV1}customer-app/address-by-pincode/`
  private fniToken = `${environment.apiUrl}${this.apiV1}fni/challenge-token/`
  private stateList = `${environment.apiUrl}${this.apiV1}states/`
  private districtList = `${environment.apiUrl}${this.apiV1}districts/`
  private getinventorydetail = `${environment.apiUrl}${this.apiV4}osp_configurator/get_inventory_details/`
  private getVehicle = `${environment.apiUrl}${this.apiV4}osp_configurator/get_vehicle_edd/`
  // ------------------------- V1 --------------------------------
  private getOffersDetailsURL = `${environment.apiUrl}${this.apiV1}fni-service/campaign_offers/`;
  private getOffersSearchDetailsURL = `${environment.apiUrl}${this.apiV1}fni-service/campaign_offers/search`
  private getPayCancelDetail = `${environment.apiUrl}${this.apiV1}admin/payment_cancelled/`
  private dealerList = `${environment.apiUrl}${this.apiV1}get_div_list_drp/`
  private generateLeadView = `${environment.apiUrl}${this.apiV1}generate_lead_view/`
  private paymentDetail = `${environment.apiUrl}${this.apiV1}admin/payment_detail/`
  private acompletion = `${environment.apiUrl}${this.apiV1}model/acompletion/`
  // private getAllApplication = `${environment.apiUrl}${this.apiV1}get_vehicle_applications/`

  private getLocation = `${environment.apiUrl}${this.apiV1}get_location/`
  private findDealer = `${environment.apiUrl}${this.apiV1}find_dealer/`
  private login = `${environment.apiUrl}${this.apiV1}login/`
  private otp = `${environment.apiUrl}${this.apiV1}send_otp/`
  private help = `${environment.apiUrl}${this.apiV1}get_faq/`
  private compare = `${environment.apiUrl}${this.apiV1}compare_dropdown/`
  private compareList = `${environment.apiUrl}${this.apiV1}compare/`
  private vehicleInfo = `${environment.apiUrl}${this.apiV1}get_vehicles_info/`
  private getBanners = `${environment.apiUrl}${this.apiV1}admin/banner/`
  private dashboardLobWise = `${environment.apiUrl}${this.apiV1}/dashboard_lob_wise/`
  private getCampaignOffersURL = `${environment.apiUrl}${this.apiV1}fni-service/campaign_offers/`
  private generatevasURL = `${environment.apiUrl}${this.apiV1}generate_vas/`
  private getSitemap = `${environment.apiUrl}${this.apiV1}admin/seo_urls/`
  private s3URL = `${environment.apiUrl}${this.apiV1}get_object/?file_name=`

  // ------------------------- V2 --------------------------------
  private getAllApplication = `${environment.apiUrl}${this.apiV2}get_vehicle_applications_v2/`
  private getBrowsByApplication = `${environment.apiUrl}${this.apiV2}admin/vc_application_img/`
  private getBlogs = `${environment.apiUrl}${this.apiV2}get_blog_list/`
  private getExploreRange = `${environment.apiUrl}${this.apiV2}vehicle_explr/`
  private signup = `${environment.apiUrl}${this.apiV2}sign_up/`
  private customerStories = `${environment.apiUrl}${this.apiV2}get_testimonials/`
  private dropDown = `${environment.apiUrl}${this.apiV2}dropdowns/`
  private getVehicleDetail = `${environment.apiUrl}${this.apiV2}get_vehicle_details/`
  private getFeature = `${environment.apiUrl}${this.apiV2}get_feature/`
  private wishlist = `${environment.apiUrl}${this.apiV2}wishlist/`
  private getDseList = `${environment.apiUrl}${this.apiV2}get_dse_list/`
  private booking = `${environment.apiUrl}${this.apiV2}td_bookings/`
  private getWishList = `${environment.apiUrl}${this.apiV2}get_wishlist/`
  private getBrands = `${environment.apiUrl}${this.apiV2}get_brand/`
  private getRating = `${environment.apiUrl}${this.apiV2}get_ratings/`
  private writeReview = `${environment.apiUrl}${this.apiV2}create_ratings/`;
  private updateReviewURL = `${environment.apiUrl}${this.apiV2}update_ratings/`
  private brandVideos = `${environment.apiUrl}${this.apiV2}get_marketing_info/`
  private refreshPaymentAPI = `${environment.apiUrl}${this.apiV2}refresh_payment/`
  private getCCEncToken = `${environment.apiUrl}${this.apiV2}cc_get_enc/`
  private getOpty = `${environment.apiUrl}${this.apiV2}get_opty_status/`
  private userDetails = `${environment.apiUrl}${this.apiV2}user_details/`
  private leads = `${environment.apiUrl}${this.apiV2}get_leads/`
  private addTestDrive = `${environment.apiUrl}${this.apiV2}book_test_drive/`
  private vehicleInfo2 = `${environment.apiUrl}${this.apiV2}get_vehicles_info/`
  private getMenuData = `${environment.apiUrl}${this.apiV2}menu_items_data/`
  private getBannersNew = `${environment.apiUrl}${this.apiV2}admin/get_banner/`
  private modelList = `${environment.apiUrl}${this.apiV2}get_models_list/`
  private ccAvenueDecryption = `${environment.apiUrl}${this.apiV2}get_credential/`
  private updateCust = `${environment.apiUrl}${this.apiV2}update_customer/`;
  private uploadKYCURL = `${environment.apiUrl}${this.apiV2}upload_user_documents/`;
  private vasURL = `${environment.apiUrl}${this.apiV2}vas_list/`
  private atDoorStepURL = `${environment.apiUrl}${this.apiV2}add_address/`
  private getAtDoorStepURL = `${environment.apiUrl}${this.apiV2}get_address/`
  private getVehicleEdd = `${environment.apiUrl}${this.apiV2}get_vehicle_edd/`
  private checkkycURL = `${environment.apiUrl}${this.apiV2}check_kyc/`
  private segmentURL = `${environment.apiUrl}${this.apiV2}admin/lob_s/`
  private getVehicleExplore = `${environment.apiUrl}${this.apiV2}vehicle_explore_data/`
  private getActivityDetails = `${environment.configurationurl}fetch_user_id_details/`
  private checkDealerPrice = `${environment.apiUrl}${this.apiV2}check_dealer_price/`
  private leadsbyreqid = `${environment.apiUrl}${this.apiV2}get_leads_by_request_id/`
  private highlightmasterData = `${environment.apiUrl}${this.apiV2}highlight_master_data/`
  private fuelTypeData = `${environment.apiUrl}${this.apiV2}get_vehicle_fuel/`
  private callSearch = `${environment.apiUrl}${this.apiV2}search_vehicle_mapping/`
  private advanceFreeSearch = `${environment.apiUrl}${this.apiV2}get_single_view_product/`
  private encryptData = `${environment.apiUrl}${this.apiV2}encrypt_data/`
  private smartFilter = `${environment.apiUrl}${this.apiV2}vehicle_smart_filter/`
  private logoutapi = `${environment.apiUrl}${this.apiV2}logout/`
  private smartSearch = `${environment.apiUrl}${this.apiV2}get_single_view_product/`
  // private smartValue = `https://digital-osp-cv-dev-ms.api.tatamotors/api/v2/cv_online/retrieve/`
  private smartValue = `${environment.apiUrl}${this.apiV2}retrieve/`
  private amc_consent_view = `${environment.apiUrl}${this.apiV2}amc_consent_view/`;
  private bannerVideoApiUrl = `${environment.apiUrl}${this.apiV2}admin/get_brand_category/`;
  private bannerApiUrl = `${environment.apiUrl}${this.apiV2}admin/get_banner/`;
  private quotation = `${environment.apiUrlProd}api/v1/digital_share/GetQuotationDocById/`
  private find_opty = `${environment.apiUrl}${this.apiV2}find_opty/`
  private fni_journey_create_lead = `${environment.apiUrl}${this.apiV2}other/create_lead/`
  private explore_page = `${environment.apiUrl}${this.apiV2}get_explore_page/`;
  private amcData = `${environment.apiUrl}api/configurator/osp_configurator_vas_filter/`

  private tataokhome = `${environment.apiUrlProd}api/v2/inventory/osp/list_inventory/`
  private tataokhomedistinct = `${environment.apiUrlProd}api/v2/inventory/osp/get_vehicle_params/`
  private tataokpdpdata = `${environment.apiUrlProd}api/v2/inventory/osp/view_inventory/`
  private tataokGetlead = `${environment.apiUrlProd}api/v2/accounts/osp/get_leads/`;
  private tataokcategory = `${environment.apiUrlProd}api/v1/masters/category/`;
  // private tataokGetLob=`${environment.apiUrlProd}api/v2/osp/masters/subcategory/`;
  // private tataokGetPPl=`${environment.apiUrlProd}api/v1/masters/sub_category_details/`;
  private tataokGetLob = `${environment.apiUrlProd}api/v2/masters/osp/subcategory_v2/`;

  private tataokGetPPl = `${environment.apiUrlProd}api/v2/masters/osp/sub_category_details_v2/`;
  private wraperAmcData = `${environment.apiUrl}api/v2/cv_online/home/vas_configurator/`
  private wraperAplication = `${environment.apiUrl}/api/v2/cv_online/get_vas_rec_appl/`
  private getLocationstates = `${environment.apiUrlProd}api/states/`
  private getLocationdistricts = `${environment.apiUrlProd}api/districts/`
  private tataokCreatelead = `${environment.apiUrlProd}api/v2/accounts/osp/create_lead_v2/`;
  private verify_ka_user = `${environment.apiUrl}${this.apiV2}verify_ka_user/`
  private financeleadlist = `${environment.apiUrl}${this.apiV2}get_financier_detail/`
  private otp1 = `${environment.apiUrl}${this.apiV2}send_otp/`
  private verify = `${environment.apiUrl}${this.apiV2}verify_otp_v3/`
  private findDealernew = `${environment.apiUrl}${this.apiV1}find_dealer/`
  private enquireFinance = `${environment.apiUrl}${this.apiV2}add_finance_interest/`
  private pincodebylatlong = `${environment.apiUrl}${this.apiV2}get_pincode_by_lat_lon/`
  // For the chatbot

  private chatBotVcNumber = `${environment.apiUrl}${this.apiV2}get_vehicle_details/`
  private wraperAplicationChatbot = `${environment.apiUrl}/api/v2/cv_online/get_vas_rec_appl/`
  private amcDataChatbot = `${environment.apiUrl}api/configurator/osp_configurator_vas_filter/`
  //leads new integration
  private leadsnew = `${environment.apiUrl}${this.apiV2}get_leads_v3/`
  private solrdata = `${environment.apiUrl}${this.apiV2}get_lead_opty/`
  private getSchemeDetail = `${environment.apiUrl}${this.apiV2}get_scheme_details/`
  private getLoyalityBalance = `${environment.apiUrl}${this.apiV2}get_user_balance/`
  private getLoyalityStatement = `${environment.apiUrl}${this.apiV2}get_customer_statement/`
  private addUserRedemption = `${environment.apiUrl}${this.apiV2}add_user_redemption/`
  private UserAaccumulation = `${environment.apiUrl}${this.apiV2}add_user_accumulation/`
  private redemptionProduct = `${environment.apiUrl}${this.apiV2}get_redemption_product_master/`
  private loyalitySignUp = `${environment.apiUrl}${this.apiV2}loyalty_signup/`
  private getStatement = `${environment.apiUrl}${this.apiV2}get_customer_statement/`
  private vastat = `${environment.apiUrl}${this.apiV2}vas_recommendation_tat_data/`
  private usedvehiclesLead = `${environment.apiUrlProd}api/v2/inventory/osp/get_customer_lead/`
//autosuggest new api
 private newAutoSuggest = `${environment.apiUrl}${this.apiV2}get_vehicle_search/`

  constructor(private http: HttpClient, private ssrcookieService: CookieService) {
    this.device_id = this.ssrcookieService.getItem('unbxd.userId') ? this.ssrcookieService.getItem('unbxd.userId') : ''
  }

  getS3Data(data: any): Observable<any> {
    return this.http.get(this.s3URL + data)
  }

  async getS3Data1(data: any) {
    return await this.http.get(this.s3URL + data)
      .toPromise().then(res => { return res; });
  }
  getBrowseByApplication(data: FormData): Observable<any> {
    return this.http.post(this.getBrowsByApplication, data).pipe(catchError(err => of(err)));
  }
  getAllApplications(data: any): Observable<any> {
    return this.http.post(this.getAllApplication, data, this.header).pipe(catchError(err => of(err)))
  }

  getBlogList(data: any) {
    return this.http.post(this.getBlogs, data, this.header).pipe(catchError(err => of(err)))
  }
  getLocations(data: any) {
    return this.http.post(this.getLocation, data, this.header).pipe(catchError(err => of(err)))
  }
  findDealers(data: any) {
    return this.http.post(this.findDealer, data, this.header).pipe(catchError(err => of(err)))
  }

  getExploreVehicle(data: any) {
    return this.http.post(this.getExploreRange, data, this.header).pipe(catchError(err => of(err)))
  }
  userSignup(data: any) {
    return this.http.post(this.signup, data, this.header).pipe(catchError(err => of(err)))
  }
  userLogin(data: any) {
    return this.http.post(this.login, data, this.header).pipe(catchError(this.handlError))
  }
  handlError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
  sentOtp(data: any) {
    return this.http.post(this.otp, data, this.header).pipe(catchError(err => of(err)))
  }
  sentOtp1(data: any) {
    return this.http.post(this.otp1, data, this.header).pipe(catchError(err => of(err)))
  }
  getCustomerStories(data: any) {
    return this.http.post(this.customerStories, data, this.header).pipe(catchError(err => of(err)))
  }

  getDropDownValue(data: any) {
    return this.http.post(this.dropDown, data, this.header).pipe(catchError(err => of(err)))
  }

  getTranslateText(data: any) {
    return this.http.post(this.translateText, data, this.header).pipe(catchError(this.handlError))

  }

  getHelpList(data: any) {
    return this.http.post(this.help, data, this.header).pipe(catchError(err => of(err)))
  }
  getVehicleDetails(data: any) {
    return this.http.post(this.getVehicleDetail, data, this.header).pipe(catchError(err => of(err)))
  }

  getDropDownList(data: any) {
    return this.http.post(this.compare, data, this.header).pipe(catchError(err => of(err)))
  }
  getVehicleInfo(data: any) {
    return this.http.post(this.vehicleInfo, data, this.header).pipe(catchError(err => of(err)))
  }

  getVehicleInfo2(data: any) {
    return this.http.post(this.vehicleInfo2, data, this.header).pipe(catchError(err => of(err)))
  }

  getCompareList(data: any) {
    return this.http.post(this.compareList, data, this.header).pipe(catchError(err => of(err)))
  }
  getBannerList(data: any) {
    return this.http.get(this.getBanners + '?' + data, this.header).pipe(catchError(err => of(err)))
  }
  getMenuItemList() {
    return this.http.post(this.getMenuData, this.header).pipe(catchError(err => of(err)))
  }
  getBannerListNew(data: any) {
    return this.http.post(this.getBannersNew, data, this.header).pipe(catchError(err => of(err)))
  }
  getFeatureList(data: any) {
    return this.http.post(this.getFeature, data, this.header).pipe(catchError(err => of(err)))
  }
  getDealerList(data: any) {
    return this.http.post(this.dealerList, data, this.header).pipe(catchError(err => of(err)))
  }
  getrefreshPayment(data: any) {
    return this.http.post(this.refreshPaymentAPI, data, this.header).pipe(catchError(err => of(err)))
  }
  generateLead(data: any) {
    return this.http.post(this.generateLeadView, data, this.header).pipe(catchError(err => of(err)))
  }

  getUserData() {
    return this.http.post(this.userDetails, this.header).pipe(catchError(err => of(err)))
  }

  getPaymentDetail(data: any) {
    return this.http.post(this.paymentDetail, data, this.header).pipe(catchError(err => of(err)))
  }
  getCCEncTokenDetail(data: any) {
    return this.http.post(this.getCCEncToken, data, this.header).pipe(catchError(err => of(err)))
  }
  addToWishlist(data: any) {
    return this.http.post(this.wishlist, data, this.header).pipe(catchError(err => of(err)))
  }

  getDSEList(data: any) {
    return this.http.post(this.getDseList, data, this.header).pipe(catchError(err => of(err)))
  }
  getBooking(data: any) {
    return this.http.post(this.booking, data, this.header).pipe(catchError(err => of(err)))
  }
  getAddressByPincodeList(data: any) {
    return this.http.post(this.addressByPincode, data, this.header).pipe(catchError(err => of(err)))
  }
  getLeads(data: any) {
    return this.http.post(this.leads, data, this.header).pipe(catchError(err => of(err)))
  }

  getOptyStatus(data: any) {
    return this.http.post(this.getOpty, data, this.header).pipe(catchError(err => of(err)))
  }
  getfniToken(data: any) {
    return this.http.post(this.fniToken, data, this.header).pipe(catchError(err => of(err)))

  }


  getBrand(data: any) {
    return this.http.post(this.getBrands, data, this.header).pipe(catchError(err => of(err)))
  }

  getPaymentCancelDetail(data: any) {
    return this.http.post(this.getPayCancelDetail, data, this.header).pipe(catchError(err => of(err)))
  }
  getWishlistData(data: any) {
    return this.http.post(this.getWishList, data, this.header).pipe(catchError(err => of(err)))
  }
  addBookTestDrive(data: any) {
    return this.http.post(this.addTestDrive, data, this.header).pipe(catchError(err => of(err)))
  }
  getCityList(data: any) {
    return this.http.post(this.getCity, data, this.header).pipe(catchError(err => of(err)))
  }
  getRatings(data: any) {
    return this.http.post(this.getRating, data, this.header).pipe(catchError(err => of(err)))
  }
  createReview(data: FormData): Observable<any> {
    return this.http.post(this.writeReview, data).pipe(catchError(this.handlError))
  }

  updateReview(data: FormData): Observable<any> {
    return this.http.post(this.updateReviewURL, data).pipe(catchError(this.handlError))
  }
  getSegment(data: any): Observable<any> {
    return this.http.post(this.segmentURL, data, this.header).pipe(catchError(err => of(err)))
  }

  getSearchModels(data: any) {
    return this.http.get(this.acompletion + '?model=' + data, this.header).pipe(catchError(err => of(err)))
  }
  getbrandVideosDetail(data: any) {
    return this.http.post(this.brandVideos, data, this.header).pipe(catchError(err => of(err)))
  }
  getModelList(data: any) {
    return this.http.post(this.modelList, data, this.header).pipe(catchError(err => of(err)))
  }
  getStateList(data: any) {
    return this.http.post(this.stateList, data, this.header).pipe(catchError(err => of(err)))
  }
  getDistrictList(data: any) {
    return this.http.post(this.districtList, data, this.header).pipe(catchError(err => of(err)))
  }
  getDashboardLobwise(data: any) {
    return this.http.post(this.dashboardLobWise, data, this.header).pipe(catchError(err => of(err)))
  }
  saveAtDoorStep(data: any) {
    return this.http.post(this.atDoorStepURL, data, this.header).pipe(catchError(err => of(err)))
  }
  getDataAtDoorStep(data: any) {
    return this.http.post(this.getAtDoorStepURL, data, this.header).pipe(catchError(err => of(err)))
  }
  generateVasLead(data: any) {
    return this.http.post(this.generatevasURL, data, this.header).pipe(catchError(err => of(err)))
  }
  getCampaignOffers(data: any) {
    return this.http.get(this.getCampaignOffersURL, data).pipe(catchError(err => of(err)))
  }
  updateCustomer(data: any) {
    return this.http.post(this.updateCust, data).pipe(catchError(err => of(err)))
  }

  uploadKYC(data: any): Observable<any> {
    return this.http.post(this.uploadKYCURL, data).pipe(catchError(err => of(err)))
  }
  getVAS(data: any) {
    return this.http.post(this.vasURL, data, this.header).pipe(catchError(err => of(err)))
  }

  getinventorydetails(data: any): Observable<any> {
    return this.http.post(this.getinventorydetail, data, this.header).pipe(catchError(err => of(err)))
  }

  getOffersDetails(): Observable<any> {
    return this.http.get(this.getOffersDetailsURL, this.header).pipe(catchError(err => of(err)))
  }
  getOffersSearchDetail(data: any): Observable<any> {
    return this.http.get(this.getOffersSearchDetailsURL, data).pipe(catchError(err => of(err)))
  }
  checkkyc(data: any): Observable<any> {
    return this.http.post(this.checkkycURL, data, this.header).pipe(catchError(err => of(err)))
  }
  getVehicleData(data: any): Observable<any> {
    return this.http.post(this.getVehicle, data, this.header).pipe(catchError(err => of(err)))
  }
  getVehicleEddData(data: any): Observable<any> {
    return this.http.post(this.getVehicleEdd, data, this.header).pipe(catchError(err => of(err)))
  }
  getSitemapDetails(data: any): Observable<any> {
    return this.http.post(this.getSitemap, data, this.header).pipe(catchError(err => of(err)))
  }

  getCCEncDetail(data: any) {
    return this.http.post(this.ccAvenueDecryption, data, this.header).pipe(catchError(err => of(err)))
  }
  getVehicleExploreData(data: any) {
    return this.http.post(this.getVehicleExplore, data, this.header).pipe(catchError(err => of(err)))
  }

  getActivityDetailsData(data: any) {
    return this.http.post(this.getActivityDetails, data, this.header).pipe(catchError(err => of(err)))
  }
  getDealerPrice(data: any) {
    return this.http.post(this.checkDealerPrice, data, this.header).pipe(catchError(err => of(err)))
  }
  gethighlightmasterdata(data: any) {
    return this.http.post(this.highlightmasterData, data, this.header).pipe(catchError(err => of(err)))
  }

  getLeadsbyrefid(data: any) {
    return this.http.post(this.leadsbyreqid, data, this.header).pipe(catchError(err => of(err)))
  }
  getFuelType(data: any) {
    return this.http.post(this.fuelTypeData, data, this.header).pipe(catchError(err => of(err)))
  }
  advanceSearch(data: any) {
    return this.http.post(this.callSearch, data, this.header).pipe(catchError(err => of(err)))
  }
  getFreeSearch(data: any) {
    return this.http.post(this.advanceFreeSearch, data, this.header).pipe(catchError(err => of(err)))
  }
  getEncryptData(data: any) {
    return this.http.post(this.encryptData, data, this.header).pipe(catchError(err => of(err)))
  }
  getSmartFilter(data: any) {
    return this.http.post(this.smartFilter, data, this.header).pipe(catchError(err => of(err)))
  }

  logoutApi(data: any) {
    return this.http.post(this.logoutapi, data).pipe(catchError(err => of(err)))
  }

  getsearchUnbxd(data: any) {
    return this.http.post(this.newAutoSuggest ,data , this.header).pipe(catchError(this.handlError))
  }

  getUnbxdData(filter, startValue, endValue, otherValues, filterinside) {
    let url = `${this.searchUnbxd}search?q=${filter}&start=${startValue}&rows=${endValue}&uid=${this.device_id}`;
    const filterGroups = {};
    let hasDuplicates = false;
    if (otherValues.length > 0 && filterinside.length > 0) {
      otherValues.forEach((ov, index) => {
        if (filterinside[index]) {
          const trimmedValue = filterinside[index].trim();
          if (!filterGroups[ov]) {
            filterGroups[ov] = [];
          } else {
            hasDuplicates = true;
          }
          filterGroups[ov].push(trimmedValue);
        }
      });

      for (const ov in filterGroups) {
        if (filterGroups.hasOwnProperty(ov)) {
          const values = filterGroups[ov].map(val => `"${val}"`).join(` OR ${ov}:`);
          url += `&filter=${ov}:${values}`;
        }
      }

      if (hasDuplicates) {
        url += '&facet.multiselect=true';
      }
    }

    return this.http.get(url, this.header).pipe(catchError(this.handlError));
  }
  getUnbxdData1(payload: any, otherValues?: any[], filterinside?: any[]) {
    let filters = '';
    const filterGroups = {};
    let hasDuplicates = false;
    if (otherValues?.length > 0 && filterinside?.length > 0) {
      const filterGroups: { [key: string]: string[] } = {};
  
      // Group filters
      otherValues.forEach((ov, index) => {
        if (filterinside[index]) {
          const trimmedValue = filterinside[index].trim();
          if (!filterGroups[ov]) {
            filterGroups[ov] = [];
          } else {
          hasDuplicates = true;
        }
          filterGroups[ov].push(trimmedValue);
        }
      });
  
      // Construct filters string (encode only values)
      Object.keys(filterGroups).forEach(ov => {
        filterGroups[ov].forEach(value => {
          const encodedValue = encodeURIComponent(`"${value}"`); // Encode only value
          filters += `filter=${ov}:${encodedValue}`;
        });
      });
    }
    if (hasDuplicates) {
      filters += '&facet.multiselect=true';
      }

    // payload.filter = filters; // Store final filter string
    if (filters) {
  payload.filter = `&${filters}`;
} else {
  payload.filter = filters;
}
 
    return this.http.post(this.newAutoSuggest, payload, this.header).pipe(
      catchError(this.handlError)
    );
  }

  


  getSmartSearch(data: any) {
    return this.http.post(this.smartSearch, data, this.header).pipe(catchError(this.handlError))
  }

  getSearchValue(data: any) {
    return this.http.post(this.smartValue, data, this.header).pipe(catchError(this.handlError))
  }

  getUnbxAutoSuggest(data:any){
    return this.http.post(this.newAutoSuggest,data , this.header).pipe(catchError(this.handlError))
  }

  get_amc_consent_view(data: any): Observable<any> {
    return this.http.post(this.amc_consent_view, data, this.header)
  }
  getBannerData(data: any): Observable<any> {
    return this.http.post(this.bannerApiUrl, data, this.header);
  }
  getBannerVideoData(requestData: any): Observable<any> {
    return this.http.post(this.bannerVideoApiUrl, requestData, this.header);
  }
  getQuotation(data: any): Observable<any> {
    return this.http.post(this.quotation, data, this.header2)
  }

  getFindOpty(data: any): Observable<any> {
    return this.http.post(this.find_opty, data, this.header)
  }

  getFniJourneyCreateLead(data: any): Observable<any> {
    return this.http.post(this.fni_journey_create_lead, data, this.header)
  }

  fnijourney_create_lead(data: any): Observable<any> {
    return this.http.post(this.fni_journey_create_lead, data, this.header)
  }
  explorePage(data: any): Observable<any> {
    return this.http.post(this.explore_page, data, this.header)
  }
  getAMCData(data: any): Observable<any> {
    return this.http.post(this.amcData, data, this.header2)
  }
  getOffersDetailsNew(data: any): Observable<any> {
    let url;
    if (data?.financierSchemeId) {
      url = `${this.getOffersDetailsURL}?pageNo=${data.offset}&noOfCampaignOffers=${data.noOfCampaignOffers}&state=${data.state}&financierSchemeId=${data.financierSchemeId}`;
    } else {
      if ((data?.lob == '' || data?.lob == undefined || data?.lob == null) &&
        (data?.ppl == '' || data?.ppl == undefined || data?.ppl == null) &&
        (data?.pl == '' || data?.pl == undefined || data?.pl == null)) {
        url = `${this.getOffersDetailsURL}?pageNo=${data?.offset}&noOfCampaignOffers=${data?.noOfCampaignOffers}&state=${data?.state}`;
      } else {
        url = `${this.getOffersDetailsURL}?pageNo=${data?.offset}&noOfCampaignOffers=${data?.noOfCampaignOffers}&lob=${data?.lob}&ppl=${data?.ppl}&pl=${data?.pl}&state=${data?.state}`;
      }
    }

    return this.http.get(url, this.header).pipe(catchError(err => of(err)));
  }
  // tata ok api
  getTataokhomedata(data: any): Observable<any> {
    return this.http.post(this.tataokhome, data, this.header)
  }
  getTataokhomedatadistinct(data: any): Observable<any> {
    return this.http.post(this.tataokhomedistinct, data, this.header)
  }
  getPdppagedetail(data: any): Observable<any> {
    return this.http.post(this.tataokpdpdata, data, this.header)
  }

  getCreateLead(data: any): Observable<any> {
    return this.http.post(this.tataokCreatelead, data, this.header)
  }
  getTataokLead(data: any): Observable<any> {
    return this.http.post(this.tataokGetlead, data, this.header)
  }
  getTataokCategory(data: any): Observable<any> {
    return this.http.post(this.tataokcategory, data, this.header)
  }
  getTataokLOB(data: any): Observable<any> {
    return this.http.post(this.tataokGetLob, data, this.header)
  }
  getTataokPPL(data: any): Observable<any> {
    return this.http.post(this.tataokGetPPl, data, this.header)
  }

  AmcWraperData(data: any): Observable<any> {
    return this.http.post(this.wraperAmcData, data, this.header)
  }
  amcAplicationData(data: any): Observable<any> {
    return this.http.post(this.wraperAplication, data, this.header)
  }

  getLocationsstate() {
    return this.http.post(this.getLocationstates, { headers: { "Content-Type": "application/json" } }).pipe(catchError(err => of(err)))
  }
  getLocationsdistrict(data: any) {
    return this.http.post(this.getLocationdistricts, data).pipe(catchError(err => of(err)))
  }
  get_verify_ka_user(data: any): Observable<any> {
    return this.http.post(this.verify_ka_user, data, this.header)
  }
  financeDealerList(data: any): Observable<any> {
    return this.http.post(this.financeleadlist, data, this.header)
  }
  verifyOtp(data: any) {
    return this.http.post(this.verify, data, this.header).pipe(catchError(err => of(err)))
  }
  getfindDealerNew(data: any) {
    return this.http.post(this.findDealernew, data, this.header).pipe(catchError(err => of(err)))
  }
  addEnquireFinancerData(data: any): Observable<any> {
    return this.http.post(this.enquireFinance, data, this.header).pipe(catchError(err => of(err)))
  }
  getPincodeBaseOnLatLong(data: any): Observable<any> {
    return this.http.post(this.pincodebylatlong, data, this.header).pipe(catchError(err => of(err)))
  }
  getVcForChatbot(data: any) {
    return this.http.post(this.chatBotVcNumber, data, this.header).pipe(catchError(err => of(err)))
  }
  amcAplicationDataChatbot(data: any): Observable<any> {
    return this.http.post(this.wraperAplicationChatbot, data, this.header)
  }
  amcChatbot(data: any): Observable<any> {
    return this.http.post(this.amcDataChatbot, data, this.header)
  }
  //leads new integration
  getLeadsnew(data: any) {
    return this.http.post(this.leadsnew, data, this.header).pipe(catchError(err => of(err)))
  }
  getsolrdata(data: any) {
    return this.http.post(this.solrdata, data, this.header).pipe(catchError(err => of(err)))
  }
  getSchemeDetails(data: any) {
    return this.http.post(this.getSchemeDetail, data, this.header).pipe(catchError(err => of(err)))
  }

  getUserBalance(data: any) {
    return this.http.post(this.getLoyalityBalance, data, this.header).pipe(catchError(err => of(err)))
  }
  getloyalityStatement(data: any) {
    return this.http.post(this.getLoyalityStatement, data, this.header).pipe(catchError(err => of(err)))
  }
  addLoyalityRedemption(data: any){
    return this.http.post(this.addUserRedemption, data, this.header).pipe(catchError(err => of(err)))
  }

  addUserAaccumulation(data: any){
    return this.http.post(this.UserAaccumulation, data, this.header).pipe(catchError(err => of(err)))
  }
  getRedemptiomProduct(data: any){
    return this.http.post(this.redemptionProduct, data, this.header).pipe(catchError(err => of(err)))
  }

  signUpLoyality(data: any){
    return this.http.post(this.loyalitySignUp, data, this.header).pipe(catchError(err => of(err)))
  }
  getLoyalState(data: any) {
    return this.http.post(this.getStatement, data, this.header).pipe(catchError(err => of(err)))
  }
  getvastat(data: any) {
    return this.http.post(this.vastat, data, this.header).pipe(catchError(err => of(err)))
  }
  getusedvehiclesLead(data: any): Observable<any> {
    return this.http.post(this.usedvehiclesLead, data, this.header)
  }
  getVehicleInfo3(data: any) {
  return this.http.post(this.newAutoSuggest, data, this.header).pipe(catchError(err => of(err)))
}
}
